import React, {useState, useEffect} from 'react'

import classes from './HistoryReply.module.css'
import {MDBRow, MDBContainer, MDBCol, MDBListGroup, MDBListGroupItem, MDBAlert} from "mdbreact";
import {isAuth} from "../../../Utils/firebaseUtils";
import firebase from "../../../Config/firebase";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import HistoryReplyCard from "./HistoryReplyCard/HistoryReplyCard";

const db = firebase.firestore()

const HistoryReply = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [noRecord, setNoRecord] = useState(false)
    const [noMoreRecord, setNoMoreRecord] = useState(false)
    const [myHistory, setMyHistory] = useState([])

    useEffect(() => {
        if (isAuth(props.auth) && !isLoaded) {
            getMyHistory(props.auth.uid)
        }
    }, [props.auth])

    const getMyHistory = (uid) => {
        db.collection("Member")
            .doc(uid)
            .collection('MyReplyHistory')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let records = []
                    docs.forEach(function (doc) {
                        const record = {
                            id: doc.id,
                            ...doc.data()
                        }
                        records.push(record)
                    })
                    setMyHistory(records)
                    setIsLoaded(true)
                } else {
                    setNoRecord(true)
                    setIsLoaded(true)
                }
            })
            .catch(err => console.err(err))
    }

    return (
        <MDBContainer>
            <MDBRow>
                <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                    <h1>
                        你的回覆紀錄
                    </h1>
                    <MDBListGroup>
                        {
                            isLoaded ?
                                noRecord ?
                                    <MDBAlert>
                                        你沒有任何回覆紀錄
                                    </MDBAlert> :
                                    myHistory.map((e, index) => {
                                        return (
                                            <MDBListGroupItem key={e.id}>
                                                <HistoryReplyCard
                                                    auth={props.auth}
                                                    data={e}
                                                />
                                            </MDBListGroupItem>
                                        )
                                    })
                                :
                                ''
                        }
                    </MDBListGroup>

                </MDBCol>
            </MDBRow>
        </MDBContainer>
    )
}
const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(HistoryReply))